import { defineNuxtPlugin } from '#app'
import useAuthUserMixin from '~~/mixins/useAuthUserMixin'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.mixin(useAuthUserMixin)
})
